import { getTimeWithTimeZone } from 'utility/general';

const useCTIExpiryDateData = ({ cti = [] }) => {
    const rawColumn = [
        {
            field: 'id',
            headerName: 'No.',
            width: 80,
            valueGetter: (params, index) => {
                return index + 1;
            },
        },
        { field: 'policyNo', headerName: 'Policy No.', width: 200 },
        {
            field: 'expiryDtm',
            headerName: 'Expiry Date',
            width: 170,
            valueGetter: (params) => {
                return params.value ? getTimeWithTimeZone(params.value).format('YYYY-MM-DD') : '-';
            },
        },
        { field: 'createdByFullName', headerName: 'Uploaded by', width: 170 },
        {
            field: 'createDtm',
            headerName: 'Upload Date',
            width: 170,
            valueGetter: (params) => {
                return params.value ? getTimeWithTimeZone(params.value).format('YYYY-MM-DD HH:mm:ss') : '-';
            },
        },
    ];

    return { columns: rawColumn, rawColumn: rawColumn, rows: cti ?? [] };
};

export default useCTIExpiryDateData;
